import { render, staticRenderFns } from "./DaumPostcodeWindow.vue?vue&type=template&id=5a827807&scoped=true&"
import script from "./DaumPostcodeWindow.vue?vue&type=script&lang=js&"
export * from "./DaumPostcodeWindow.vue?vue&type=script&lang=js&"
import style0 from "./DaumPostcodeWindow.vue?vue&type=style&index=0&id=5a827807&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a827807",
  null
  
)

export default component.exports